import { useResource } from "@/services";

export const useServiceCatalogVariant = <T, P>(resource: string, params: P) => {
  const { all, add, edit, get, deleteOne, patch, deleteByIds } = useResource<T>(resource);

  return { all, add, edit, get, deleteOne, patch, deleteByIds };
};
